module.exports = {"id":"182152","name":"Koo Ja Cheol","rating":"76","photo":"./data/images/photos/1/182152.png","club":{"name":"FC Augsbourg","logo":"./data/images/clubs/FCAugsbourg.png"},"positions":["MOC","MC","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KooJaCheol0.json
// module id = 2403
// module chunks = 0